import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SignUpUser, reset } from "../features/signUpSlice.js";
import Header from "./Header.jsx";
import axios from "axios";
import Cookies from "js-cookie";
import parseHtml from "html-react-parser";
import { API_URL, SECRET_SESSION } from "../constants";
import { encrypt, decrypt_res } from "./shares/GlobalFunction.jsx";
import Loader from "./shares/Loader.jsx";

const baseURL = API_URL + "/login/tokensignup";
const baseURL_Login = API_URL + "/login/info";
function SignUp() {
  const [isLoadingPage, setIsLoadingPage] = React.useState(true);
  const [effectsCompleted, setEffectsCompleted] = React.useState(0);
  const [post_setting, setPostSetting] = React.useState(null);
  const navigate = useNavigate();

  React.useEffect(() => {
    axios.post(baseURL_Login).then((response) => {
      response.data.res = JSON.parse(
        decrypt_res(response.data.res, SECRET_SESSION)
      );
      setPostSetting(response.data.res);
      if (response.data.res.register_akun === 0) {
        navigate("/login");
        return;
      }
    });
  }, [navigate]);

  const [post, setPost] = React.useState(null);
  React.useEffect(() => {
    axios.post(baseURL).then((response) => {
      response.data.res = JSON.parse(
        decrypt_res(response.data.res, SECRET_SESSION)
      );
      setPost(response.data.res);
      setEffectsCompleted((prev) => prev + 1);
    });
  }, []);

  React.useEffect(() => {
    if (effectsCompleted >= 1) {
      setIsLoadingPage(false);
    }
  }, [effectsCompleted]);

  // if (!post) return null;

  const [nama_lengkap, setNamaLengkap] = useState("");
  const [asal_instansi, setNamaInstansi] = useState("");
  const [grup_peserta, setGrupPeserta] = useState("");
  const [jenis_kelamin, setJenisKelamin] = useState("");
  const [token, setToken] = useState("");

  const dispatch = useDispatch();
  const { user, isError, isSuccess, isLoading, message } = useSelector(
    (state) => state.authSignUp
  );

  useEffect(() => {
    if (user || isSuccess) {
      Cookies.set("user-baru", user.msg, { expires: 1 }); // Expires in 1 day
      // const userBaru = Cookies.get("user-baru");
      navigate("/login");
    }

    dispatch(reset());
  }, [user, isSuccess, dispatch, navigate]);

  const Auth = (e) => {
    e.preventDefault();
    dispatch(
      SignUpUser({
        nama_lengkap,
        asal_instansi,
        grup_peserta,
        jenis_kelamin,
        token,
      })
    );
  };

  const toLogin = () => {
    navigate("/login");
  };

  if (isLoadingPage) {
    return <Loader />;
  }

  return (
    <div className="App">
      <div className="App-header">
        <Header app_name={post_setting && post_setting.alamat} />
        <div
          className="login-container Bg-tutwuri contentLogin z-10 bg-white border-1 border-grey-800 rounded-xl shadow-xl p-6 "
          style={{
            width: "450px",
            minHeight: "200px",
            marginTop: "100px",
          }}
        >
          <form onSubmit={Auth}>
            <p className="text-center font-bold text-base">
              Halaman Pendaftaran
            </p>

            <p className="text-center">Silakan masukkan identitas Anda !</p>

            {isError && (
              <p
                className="bg-red-100 border text-center border-red-400 text-red-700 px-4 py-3 rounded relative"
                role="alert"
              >
                {parseHtml(message)}
              </p>
            )}

            <input
              className="appearance-none bg-white border-b-2 border-gray-200 mt-2 mb-2 p-2 rounded-xl w-full"
              type="text"
              placeholder="Nama Lengkap"
              aria-label=""
              name="nama_lengkap"
              value={nama_lengkap}
              onChange={(e) => setNamaLengkap(e.target.value)}
            />

            <input
              className="appearance-none bg-white border-b-2 border-gray-200 mt-2 mb-2 p-2 rounded-xl w-full"
              type="text"
              placeholder="Nama Sekolah/Perguruan Tinggi"
              aria-label=""
              name="asal_instansi"
              value={asal_instansi}
              onChange={(e) => setNamaInstansi(e.target.value)}
            />

            <select
              className="appearance-none bg-white border-b-2 border-gray-200 mt-2 mb-2 p-2 rounded-xl w-full"
              type="text"
              placeholder="Asal Provinsi"
              aria-label=""
              name="grup_peserta"
              onChange={(e) => setGrupPeserta(e.target.value)}
            >
              <option value="">Pilih Asal Provinsi</option>
              <option value="ACEH">ACEH</option>
              <option value="BALI">BALI</option>
              <option value="BANGKA BELITUNG">BANGKA BELITUNG</option>
              <option value="BANTEN">BANTEN</option>
              <option value="BENGKULU">BENGKULU</option>
              <option value="DI YOGYAKARTA">DI YOGYAKARTA</option>
              <option value="DKI JAKARTA">DKI JAKARTA</option>
              <option value="GORONTALO">GORONTALO</option>
              <option value="JAMBI">JAMBI</option>
              <option value="JAWA BARAT">JAWA BARAT</option>
              <option value="JAWA TENGAH">JAWA TENGAH</option>
              <option value="JAWA TIMUR">JAWA TIMUR</option>
              <option value="KALIMANTAN BARAT">KALIMANTAN BARAT</option>
              <option value="KALIMANTAN SELATAN">KALIMANTAN SELATAN</option>
              <option value="KALIMANTAN TENGAH">KALIMANTAN TENGAH</option>
              <option value="KALIMANTAN TIMUR">KALIMANTAN TIMUR</option>
              <option value="KALIMANTAN UTARA">KALIMANTAN UTARA</option>
              <option value="KEPULAUAN RIAU">KEPULAUAN RIAU</option>
              <option value="LAMPUNG">LAMPUNG</option>
              <option value="MALUKU">MALUKU</option>
              <option value="MALUKU UTARA">MALUKU UTARA</option>
              <option value="NUSA TENGGARA BARAT">NUSA TENGGARA BARAT</option>
              <option value="NUSA TENGGARA TIMUR">NUSA TENGGARA TIMUR</option>
              <option value="PAPUA">PAPUA</option>
              <option value="PAPUA BARAT">PAPUA BARAT</option>
              <option value="RIAU">RIAU</option>
              <option value="SULAWESI BARAT">SULAWESI BARAT</option>
              <option value="SULAWESI SELATAN">SULAWESI SELATAN</option>
              <option value="SULAWESI TENGAH">SULAWESI TENGAH</option>
              <option value="SULAWESI TENGGARA">SULAWESI TENGGARA</option>
              <option value="SULAWESI UTARA">SULAWESI UTARA</option>
              <option value="SUMATERA BARAT">SUMATERA BARAT</option>
              <option value="SUMATERA SELATAN">SUMATERA SELATAN</option>
              <option value="SUMATERA UTARA">SUMATERA UTARA</option>
            </select>

            <select
              className="appearance-none bg-white border-b-2 border-gray-200 mt-2 mb-2 p-2 rounded-xl w-full"
              type="text"
              placeholder="Jenis Kelamin"
              aria-label=""
              name="jenis_kelamin"
              onChange={(e) => setJenisKelamin(e.target.value)}
            >
              <option value="">Pilih Jenis Kelamin</option>
              <option value="L">Laki-Laki</option>
              <option value="P">Perempuan</option>
            </select>

            <p className="mt-5 text-left font-bold text-2xl">
              Token : {post ? post.token : ""}
            </p>
            <input
              className="appearance-none bg-white border-b-2 border-gray-200 mb-2 p-2 rounded-xl w-full"
              type="text"
              placeholder="Ketikkan Token"
              aria-label=""
              name="token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
            />

            <div className="text-center mt-2">
              <div className="flex items-center ">
                <button
                  onClick={toLogin}
                  type="button"
                  className="w-full bg-red-500 hover:bg-blue-800 text-white py-2 px-4 mr-2 rounded-2xl"
                >
                  Sudah Punya Akun
                </button>
                <button
                  type="submit"
                  className="w-full bg-blue-500 hover:bg-blue-800 text-white py-2 px-4 rounded-2xl"
                >
                  {isLoading ? "Loading..." : "Daftar"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
export default SignUp;
